/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IManageFormScope extends IBaseFormScope {

    }

    export class ManageForm extends BaseForm {
        public templateUrl = './app/views/directives/manageForm/manageForm.html';
        public controller = [
            '$scope', 'angularLoadService', 'formSectionService', 'ModalService', '$http',
            'dataSourceService', 'formService', 'formDataService', 'securityMatrixService', 'growl',
            'formCodeFunctionService', 'customDivService',
            'manageProcessDataConfigurationService', 'apiActionService','deleteService', ManageFormController ];
    }

    export class ManageFormModel extends BaseFormModel {
        public setupImplementedForm() {

        }

        public addAssignmentSection() {
            var manageSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.Assignment);

            manageSection.assignmentConfiguration = this.formService.createAssigmentConfiguration();
            manageSection.assignmentConfiguration.isReadOnly = false;
            this.save();
        }

        public addTimeTrackers() {
            var section = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.TimeTrackers);

            this.save();
        }

        public addDocuments() {
            var documentSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.Documents);

            documentSection.manageDocumentsConfiguration = this.formService.createManageDocumentConfiguration();
            documentSection.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix = this.securityMatrixService.createSecurityMatrix(false);
            documentSection.title = "Documents";

            documentSection.manageDocumentsConfiguration.canUploadDocumentsSecurityMatrix.matrixType = Wars.Domain.Model.Codes.Enums.SecurityMatrixType.HideOrShow;

            this.save();
        }

        public addFieldHistory() {
            this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.FieldHistory);

            this.save();
        }

        public addEmbeddedFormSection() {
            var manageSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.EmbeddedForm);
            this.save();
        }

        public addApiGrid() {
            var manageSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.ApiGrid);
            this.save();
        }

        public addNotificationsSent() {
            this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.NotificationsSent);

            this.save();
        }

        public addProcessData() {
            var processDataSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.ProcessData);

            processDataSection.manageProcessDataConfiguration = this.manageProcessDataConfigurationService.createManageProcessDataConfiguration();
            processDataSection.manageProcessDataConfiguration.showHistory = false;

            this.save();
        }

        public addProcessEvent() {
            var processEventSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.ProcessEvent);

            processEventSection.manageProcessEventConfiguration = this.manageProcessDataConfigurationService.createManageProcessEventConfiguration();

            this.save();
        }

        public addRelatedProcess() {
            this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.RelatedProcess);

            this.save();
        }

        public addReview() {
            this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.Review);

            this.save();
        }

        public addStatuses() {
            var manageSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.Statuses);

            manageSection.manageStatusConfiguration = this.formService.createManageStatusConfiguration();
            manageSection.manageStatusConfiguration.autoExpand = false;
            manageSection.manageStatusConfiguration.allowThreadedComments = false;
            manageSection.manageStatusConfiguration
                .manageStatusType = Wars.Domain.Model.Codes.Enums.ManageStatusType.StatusesAndStatesFlat;

            this.save();
        }

        public addThreadedComments() {
            var manageSection = this.addSection(Wars.Domain.Model.Codes.Enums.ManageSectionType.ThreadedComments);
            manageSection.commentThreadConfiguration = this.formService.createCommentThreadConfiguration();

            this.save();
        }

        private addSection(sectionType: Wars.Domain.Model.Codes.Enums.ManageSectionType) {
            let newManageSection = this.formService.createManageSection();

            newManageSection.manageSectionType = sectionType;
            newManageSection.position = this.formConfiguration.myManageSections.length;
            newManageSection.title = "New Manage Section Title";
            newManageSection.sectionDisplayType = Wars.Domain.Model.Codes.Enums.FormSectionDisplayType.Panel;
            newManageSection.securityMatrix = this.securityMatrixService.createSecurityMatrix(false, false);

            this.formConfiguration.myManageSections.push(newManageSection);

            return newManageSection;
        }
    }

    export class ManageFormController extends BaseFormController {
        constructor(
            scope: IManageFormScope,
            angularLoader: services.AngularLoadService,
            formSectionService: services.FormSectionService,
            modalService: any,
            httpService: angular.IHttpService,
            dataSourceService: services.DataSourceService,
            formService: services.FormService,
            formDataService: services.FormDataService,
            securityMatrixService: services.SecurityMatrixService,
            growl: angular.growl.IGrowlService,
            formCodeFunctionService: services.FormCodeFunctionService,
            customDivService: services.CustomDivService,
            manageProcessDataConfigurationService: services.ManageProcessDataConfigurationService,
            apiActionService: services.ApiActionService,
            deleteService:services.DeleteService) {

            scope.model = new ManageFormModel(angularLoader,
                formSectionService,
                modalService,
                httpService,
                dataSourceService,
                formService,
                scope.process,
                formDataService,
                growl,
                formCodeFunctionService,
                customDivService,
                manageProcessDataConfigurationService,
                apiActionService,
                securityMatrixService,deleteService,scope);

            super(scope);
        }
    }
}

warsApp.registerDirective('ManageForm', []);